export default () => ({
  SYS_FILEDOWNLOAD(fileID, { isAutoDown } = { isAutoDown: true }) {
    const urls = [process.env.VUE_APP_FILES_DOMAIN, 'download', fileID]
    let url = urls
      .filter(Boolean)
      .map((t) => t.replace(/(^\/)|(\/$)/g, ''))
      .join('/')
    if (!url.startsWith('http') && !url.startsWith('blob:')) {
      url = '/' + url
    }
    if (isAutoDown) {
      window.open(url)
    }
    return
  }
})
